import React, { Component } from 'react'
import Link from '@material-ui/core/Link'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as actions from './redux/actions'
import Spinner from 'common/Spinner'
class MainFiltros extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filtroActual: 'MARCA',
            minP: 0,
            maxP: 0,
            minKm: 0,
            maxKm: 0,
            anioDesde: 0,
            anioHasta: 0,
            minInstalmentAmount: 0,
            maxInstalmentAmount: 0,
        }
    }

    calculateKmMax = filtro => Math.round(filtro.kilometraje_max / 2.5)

    handleChangeFilter = filtroActual => {
        this.setState({ filtroActual })
    }

    setValue = e => {
        let { name, value } = e.target
        this.setState({
            [name]: parseFloat(value)
        })
    }

    onChangeForRangeFilters = (filtro, valor, min, max) => {
        if (valor === undefined) {
            return this.props.onChangeFiltros({
                name: filtro,
                value: valor
            })
        } 
        if (max > min && max !== min && !isNaN(max) && !isNaN(min)) {
            return this.props.onChangeFiltros({
                name: filtro,
                value: valor,
                toggle: true
            })
        }
    }

    onChangeFiltros = (filtro, valor) => {
        const maxP = parseFloat(this.state.maxP)
        const minP = parseFloat(this.state.minP)
        const minInstalmentAmount = parseFloat(this.state.minInstalmentAmount)
        const maxInstalmentAmount = parseFloat(this.state.maxInstalmentAmount)
        if (filtro === 'mejor_precio') {
            valor = 'true'
            filtro = 'best_price'
        }
        if (filtro === 'precio_venta') {
            this.onChangeForRangeFilters(filtro, valor, minP, maxP)
        } else if (filtro === 'instalment_amount') {
            this.onChangeForRangeFilters(filtro, valor, minInstalmentAmount, maxInstalmentAmount)
        } else {
            this.props.onChangeFiltros({ name: filtro, value: valor, toggle: true })
        }
    }

    kmPersonalizadoTemplate = () => {
        const { minKm, maxKm } = this.state
        return (
            <>
                <div>
                    <p className='small m-1 pl-4'>Kilometros</p>
                    <div className='d-flex flex-column px-4 py-2'>
                        <input
                            type='number'
                            className={`form-control form-control-sm my-1 mb-2 ${
                                maxKm > minKm ? 'input-novalid' : 'input-valid'
                            }`}
                            onChange={e => this.setValue(e)}
                            name={'minKm'}
                            value={minKm}
                            min='0'
                        />
                        <input
                            type='number'
                            className={`form-control form-control-sm my-1 mb-2 ${
                                maxKm > minKm ? 'input-novalid' : 'input-valid'
                            }`}
                            onChange={e => this.setValue(e)}
                            name={'maxKm'}
                            value={maxKm}
                            min='0'
                        />
                        {isNaN(minKm) || isNaN(maxKm) || (maxKm <= minKm) ? (
                            <p className='texto-error-precios'>Ingrese un valor correcto</p>
                        ) : (
                            ''
                        )}
                        <button
                            type='button'
                            className='btn btn-sm btn-block btn-filtrar text-center'
                            onClick={() => {
                                this.onChangeFiltros('kilometros', `${minKm},${maxKm}`)
                            }}
                            disabled={(isNaN(minKm) || isNaN(maxKm)) || maxKm <= minKm}
                        >
                            Filtrar
                        </button>
                    </div>
                </div>
            </>
        )
    }

    precioTemplate = () => {
        const { minP, maxP } = this.state
        return (
            <>
                <li
                    className={`dropdown-item fondo-items ${
                        this.props.filters.precio_venta === undefined ? 'selected' : ''
                    }`}
                    onClick={() => this.onChangeFiltros('precio_venta', undefined)}
                >
                    <Link
                        className={`m-1 enlace-filtro`}
                        style={{ cursor: 'pointer' }}
                    >
                        Ver Todos
                    </Link>
                </li>
                <li className='dropdown-item' style={{ background: '#f6f6f6' }}>
                    <p className='small m-1'>Rango Personalizado</p>
                    <div className='d-flex'>
                        <div>
                            <input
                                type='number'
                                className={`form-control form-control-sm my-1 mb-2 ${
                                    maxP > minP ? 'input-novalid' : 'input-valid'
                                }`}
                                onChange={e => this.setValue(e)}
                                name={'minP'}
                                value={minP}
                                min='0'
                            />
                            <input
                                type='number'
                                className={`form-control form-control-sm my-1 mb-2 ${
                                    maxP > minP ? 'input-novalid' : 'input-valid'
                                }`}
                                onChange={e => this.setValue(e)}
                                name={'maxP'}
                                value={maxP}
                                min='0'
                            />
                            {isNaN(minP) || isNaN(maxP) || (maxP <= minP) ? (
                                <p className='texto-error-precios'>Ingrese un valor correcto</p>
                            ) : (
                                ''
                            )}
                            <button
                                type='button'
                                className='btn btn-sm btn-block btn-filtrar text-center'
                                onClick={() =>
                                    this.onChangeFiltros(
                                        'precio_venta',
                                        `${minP}, ${maxP}`
                                    )
                                }
                                disabled={(isNaN(minP) || isNaN(maxP)) || maxP <= minP}
                            >
                                Filtrar
                            </button>
                        </div>
                    </div>
                </li>
            </>
        )
    }

    instalmentAmountTemplate = () => {
        const { minInstalmentAmount, maxInstalmentAmount } = this.state
        return (
            <>
                <li
                    className={`dropdown-item fondo-items ${
                        this.props.filters.instalment_amount ? '' : 'selected'
                    }`}
                    onClick={() => this.onChangeFiltros('instalment_amount', undefined)}
                >
                    <Link
                        className={`m-1 enlace-filtro`}
                        style={{ cursor: 'pointer' }}
                    >
                        Ver Todos
                    </Link>
                </li>
                <li className='dropdown-item' style={{ background: '#f6f6f6' }}>
                    <p className='small m-1'>Rango Personalizado</p>
                    <div className='d-flex'>
                        <div>
                            <input
                                type='number'
                                className={`form-control form-control-sm my-1 mb-2 ${
                                    maxInstalmentAmount > minInstalmentAmount ? 'input-novalid' : 'input-valid'
                                }`}
                                onChange={e => this.setValue(e)}
                                name={'minInstalmentAmount'}
                                value={minInstalmentAmount}
                                min='0'
                            />
                            <input
                                type='number'
                                className={`form-control form-control-sm my-1 mb-2 ${
                                    maxInstalmentAmount > minInstalmentAmount ? 'input-novalid' : 'input-valid'
                                }`}
                                onChange={e => this.setValue(e)}
                                name={'maxInstalmentAmount'}
                                value={maxInstalmentAmount}
                                min='0'
                            />
                            {isNaN(minInstalmentAmount) || isNaN(maxInstalmentAmount) || (maxInstalmentAmount <= minInstalmentAmount) ? (
                                <p className='texto-error-precios'>Ingrese un valor correcto</p>
                            ) : (
                                ''
                            )}
                            <button
                                type='button'
                                className='btn btn-sm btn-block btn-filtrar text-center'
                                onClick={() =>
                                    this.onChangeFiltros(
                                        'instalment_amount',
                                        `${minInstalmentAmount}, ${maxInstalmentAmount}`
                                    )
                                }
                                disabled={
                                    (isNaN(minInstalmentAmount) || isNaN(maxInstalmentAmount)) || 
                                    maxInstalmentAmount <= minInstalmentAmount
                                }
                            >
                                Filtrar
                            </button>
                        </div>
                    </div>
                </li>
            </>
        )
    }

    handleAnios = (filtro, tipo) => {
        const { anioDesde, anioHasta } = this.state
        return (
            <>
                {
                    filtro.map((counter, index) => {
                        // eslint-disable-next-line eqeqeq
                        const hasFiltroActual = this.props.filters[tipo] == counter[tipo]
                        return <p
                            key={index}
                            className={`p-1 mb-0 fondo-items ${
                                hasFiltroActual ? 'selected' : ''
                            } ${counter[tipo] === null ? 'd-none' : ''}`}
                            onClick={() => {
                                this.onChangeFiltros(tipo, `${counter[tipo]}`)
                            }}
                        >
                            <Link className='enlace-filtro'>
                                {`${counter[tipo]}`}
                            </Link>
                        </p>
                    })
                }
                <>
                    {
                        <div>
                            <p className='small m-1 pl-4'>Años</p>
                            <div className='d-flex flex-column px-4 py-2'>
                                <input
                                    type='number'
                                    className={`form-control form-control-sm my-1 mb-2 ${
                                        anioHasta > anioDesde ? 'input-novalid' : 'input-valid'
                                    }`}
                                    onChange={e => this.setValue(e)}
                                    name={'anioDesde'}
                                    value={anioDesde}
                                    min='0'
                                />
                                <input
                                    type='number'
                                    className={`form-control form-control-sm my-1 mb-2 ${
                                        anioHasta > anioDesde ? 'input-novalid' : 'input-valid'
                                    }`}
                                    onChange={e => this.setValue(e)}
                                    name={'anioHasta'}
                                    value={anioHasta}
                                    min='0'
                                />
                                {isNaN(anioDesde) || isNaN(anioHasta) || (anioHasta <= anioDesde) ? (
                                    <p className='texto-error-precios'>Ingrese un valor correcto</p>
                                ) : (
                                    ''
                                )}
                                <button
                                    type='button'
                                    className='btn btn-sm btn-block btn-filtrar text-center'
                                    onClick={() => {
                                        this.onChangeFiltros('año', `${anioDesde},${anioHasta}`)
                                    }}
                                    disabled={(isNaN(anioDesde) || isNaN(anioHasta)) || anioHasta <= anioDesde}
                                >
                                    Filtrar
                                </button>
                            </div>
                        </div>
                    }
                </>

            </>)
    }

    tipoDeMapeo = (filtro, tipo) => {
        const mapeoFunciones = {
            'concesionarios': () => this.mapeoLista(filtro, 'car_lot_id'),
            'marca': () => this.mapeoLista(filtro, 'brand'),
            'modelos': () => this.mapeoLista(filtro, 'model'),
            'combustible': () => this.mapeoLista(filtro, 'combustible'),
            'tipo_venta': () => filtro.length !== 0 ? this.tipoVenta(filtro) : null,
            'transmision': () => this.mapeoLista(filtro, 'transmision'),
            'kilometraje': () => {
                if(Array.isArray(filtro)){
                    return this.kilometraje(filtro[0])
                } 
                return this.kilometraje(filtro)
            },
            'precios': () => this.precioTemplate(),
            'instalmentAmount': () => this.instalmentAmountTemplate(),
            'segmentos': () => this.mapeoLista(filtro, 'segmento'),
            'años': () => this.handleAnios(filtro, 'año'),
            'sucursales': () => this.mapeoLista(filtro, 'branch_office_id'),
            'mejor_precio': () => this.mapeoLista(filtro, 'mejor_precio'),
            'pea': () => this.mapeoLista(filtro, 'pea')
        }
        return mapeoFunciones[tipo] ? mapeoFunciones[tipo]() : null
    }

    mapeoLista = (filtro, tipo) => {
        return filtro
            ? filtro.map((counter, index) => {
                let hasBestPriceFalse = counter?.best_price === 0
                if (hasBestPriceFalse) {
                    return
                }

                let hasFiltroActual = this.props.filters[tipo] === counter[tipo]
                if (tipo === 'mejor_precio') {
                    hasFiltroActual = this.props.filters['best_price'] === (counter['best_price'] ? 'true' : null)
                }

                let spanContent
                if (tipo === 'branch_office_id') {
                    const branchOffice = this.searchByBranchOffice(
                        counter[tipo],
                        counter['car_lot_id']
                    )
                    if (branchOffice === undefined) {
                        return null
                    }
                    spanContent = `${branchOffice.branchOfficeName} - ${branchOffice.carLotName}`
                } else if (tipo === 'car_lot_id') {
                    spanContent = this.searchByCarLot(counter[tipo])
                } else if (tipo === 'pea') {
                    spanContent = counter[tipo] === 'true' ? 'Con PEA' : 'Sin PEA'
                } else {
                    spanContent = counter[tipo]
                }

                return (
                    <p
                        key={index}
                        className={`p-1 mb-0 fondo-items ${
                            hasFiltroActual ? 'selected' : ''
                        } ${counter[tipo] === null ? 'd-none' : ''}`}
                        onClick={() => {
                            this.onChangeFiltros(tipo, `${counter[tipo]}`)
                        }}
                    >
                        <Link className='enlace-filtro'>
                            <span>{spanContent}</span>
                            {hasFiltroActual ? (
                                <ClearIcon />
                            ) : (
                                ''
                            )}
                        </Link>
                    </p>
                )
            })
            : null
    }

    kilometraje = filtro => {
        const {
            kilometraje_max = 0,
            kilometraje_min = 0
        } = filtro

        const maxCalculated = this.calculateKmMax(filtro)
        const media = Math.round(Math.round(maxCalculated / 10000) * 10000)
        const mediaDividedByTwo = media / 2
        const { filters } = this.props
        const isSelected = value => filters.kilometros === value

        return (
            <>
                {kilometraje_max === kilometraje_min ? (
                    <KmOption
                        label={`0 a ${filtro.kilometraje_max} km`}
                        value={`0,${filtro.kilometraje_max}`}
                        onChange={this.onChangeFiltros}
                        isSelected={this.props.filters.kilometros !== undefined}
                    />
                ) : maxCalculated > 9999 ? (
                    <>
                        <KmOption
                            label={`0 a ${mediaDividedByTwo} km`}
                            value={`0,${mediaDividedByTwo}`}
                            onChange={this.onChangeFiltros}
                            isSelected={isSelected(`0,${mediaDividedByTwo}`)}
                            clearable
                        />
                        <KmOption
                            label={`${mediaDividedByTwo} a ${media} km`}
                            value={`${mediaDividedByTwo},${media}`}
                            onChange={this.onChangeFiltros}
                            isSelected={isSelected(`${mediaDividedByTwo},${media}`)}
                            clearable
                        />
                        <KmOption
                            label={`${media} km o más`}
                            value={`${media},${9999999}`}
                            onChange={this.onChangeFiltros}
                            isSelected={isSelected(`${media},${9999999}`)}
                            clearable
                        />
                    </>
                ) : (
                    <KmOption
                        label={'Ver todos'}
                        value={`0,${filtro.kilometraje_max}`}
                        onChange={this.onChangeFiltros}
                        isSelected={isSelected(`0,${filtro.kilometraje_max}`)}
                    />
                )}
                {this.kmPersonalizadoTemplate()}
            </>
        )
    }

    sortArrayFilters = array => {
        let resArr = []
        for (let i = 0; i < array.length; i++) {
            if (array[i] === 'concesionarios') {
                resArr.splice(1, 0, array[i])
            } else if (array[i] === 'mejor_precio') {
                resArr.splice(0, 0, array[i])
            } else {
                resArr.push(array[i])
            }
        }
        return resArr
    }

    searchByCarLot = id => {
        let arrAux = this.props.common.user?.license?.company?.Car_lots
        for (let i = 0; i < arrAux.length; i++) {
            if (arrAux[i].id === id) {
                return arrAux[i].name
            }
        }
    }

    searchByBranchOffice = (branch_office_id, car_lot_id) => {
        for (const i in this.props.common.user?.license?.company?.Car_lots) {
            const element = this.props.common.user.license.company.Car_lots[i]
            if (element.id === car_lot_id) {
                for (const j in element.Branch_offices) {
                    const item = element.Branch_offices[j]
                    if (item.id === branch_office_id) {
                        return { branchOfficeName: item.name, carLotName: element.name }
                    }
                }
            }
        }
    }

    tipoVenta = filtro => {
        let venta_directa = null
        let venta_convencional = null
        for (let tipo in filtro) {
            // eslint-disable-next-line no-unused-expressions
            if (filtro[tipo].venta_directa) {
                venta_directa = true
            } else if (filtro[tipo].venta_convencional) {
                venta_convencional = true
            }
        }
        return (
            <>
                <p
                    className={`mb-0 p-1 fondo-items ${
                        this.props.filters.venta_directa ? 'selected' : ''
                    }`}
                >
                    <Link
                        onClick={() => {
                            this.onChangeFiltros('venta_directa', true)
                        }}
                    >
                        {`Directa (${venta_directa ? 'Si' : 'No'})`}
                    </Link>
                </p>
                <p
                    className={`mb-0 p-1 fondo-items ${
                        this.props.filters.venta_convencional ? 'selected' : ''
                    }`}
                >
                    <Link
                        onClick={() => {
                            this.onChangeFiltros('venta_convencional', true)
                        }}
                    >
                        {`Convencional (${venta_convencional ? 'Si' : 'No'})`}
                    </Link>
                </p>
            </>
        )
    }

    mapFilterNames = {
        tipo_venta: 'tipo de venta',
        transmision: 'transmisión',
        mejor_precio: 'mejor precio',
        pea: 'pea',
        instalmentAmount: 'precios',
    }

    render() {
        const paginationKeys = this.sortArrayFilters(
            Object.keys(this.props.counters)
        )
        return (
            <>
                <div className='d-flex align-items-center text-center'>
                    <p className='p-3 mb-0 titulo-filtro'>FILTRA TU BÚSQUEDA</p>
                </div>
                {
                    this.props.isPending
                        ? <div className='text-center mb-3'><Spinner small centered /></div>
                        : <div id='accordion' className='accordion'>
                            {paginationKeys.length > 0 &&
                                paginationKeys.map((keyFiltro, i) => (
                                    <div
                                        key={keyFiltro}
                                        className={`${
                                            ((keyFiltro === 'kilometraje' || keyFiltro === 'años' || keyFiltro === 'sucursales') &&
                                                this.props.filters.tipo === 'nuevo') || (keyFiltro === 'tipo_venta' && (this.props.filters.tipo === undefined || this.props.filters.tipo === 'usado'))
                                                ? 'd-none'
                                                : 'card'
                                        }`}
                                    >
                                        <div className='card-header p-0' id={`heading${i}`}>
                                            <h5 className='mb-0'>
                                                <button
                                                    className='btn-header-filtro text-uppercase p-2'
                                                    data-toggle='collapse'
                                                    data-target={`#collapse${i}`}
                                                    aria-expanded='true'
                                                    aria-controls={`collapse${i}`}
                                                >
                                                    {this.mapFilterNames[keyFiltro] || keyFiltro}
                                                </button>
                                            </h5>
                                        </div>
                                        <div
                                            id={`collapse${i}`}
                                            className='collapse'
                                            aria-labelledby={`heading${i}`}
                                            data-parent='#accordion'
                                        >
                                            <div className='card-body p-0'>
                                                {this.tipoDeMapeo(
                                                    this.props.counters[keyFiltro],
                                                    keyFiltro
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                }
            </>
        )
    }
}
const ClearIcon = () => (<i className='material-icons-outlined clear-filter'>clear</i>)

const KmOption = ({ label, value, onChange, isSelected = false, clearable = false }) => {
    return (
        <p className={`mb-0 p-1 fondo-items ${isSelected ? 'selected' : ''}`}>
            <Link className='enlace-filtro' onClick={() => onChange('kilometros', value)} >
                {label}
                {isSelected && clearable && (<ClearIcon/>)}
            </Link>
        </p>
    )
}
/* istanbul ignore next */
function mapStateToProps(state) {
    return {
        common: state.common
    }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...actions }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainFiltros)
